<template>
<div>
    <Breadcrumbs main="Admin" submain="" title="Feedback" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body"> 
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="feedback_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(is_satisfied)="row">
                                        <div v-if="row.item.is_satisfied">
                                            <b-badge variant="success">Satisfied</b-badge>
                                        </div>
                                        <div v-else>
                                            <b-badge variant="danger">Not Satisfied</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(userFeedback)="row">
                                        <div v-if="row.item.userFeedback" style="max-width: 450px;">
                                            <h7>{{ row.item.userFeedback }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(prompt)="row">
                                        <div v-if="row.item.prompt" style="max-width: 300px;">
                                            <div v-html="row.item.prompt.slice(0, 70)"></div>
                                        </div>
                                    </template>

                                    <template #cell(ai_result)="row">
                                        <div v-if="row.item.ai_result" style="max-width: 300px;">
                                            <div v-html="row.item.ai_result.slice(0, 70)"></div>
                                        </div>
                                    </template>

                                    <template #cell(created_at)="row">
                                        <h7 v-if="row.item.created_at">{{ formatDate(row.item.created_at).date }} <br> {{ formatDate(row.item.created_at).time }}</h7>
                                    </template> 

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div @click="viewFeedback(data.item)">
                                                    <feather type="eye" size="22px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="View" v-b-modal.modal-view-feedback></feather>
                                                </div>
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteFeedback(data.item.id)" title="Delete"></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Feedback View Modal -->
    <b-modal title="Prompt & AI Generated Result" id="modal-view-feedback" size="lg" centered hide-footer>
        <div>
            <div>
                <strong>Prompt:</strong>
                <div v-html="prev"></div>
            </div>
            <div class="mt-3">
                <strong>AI Result:</strong>
                <div v-html="result"></div>
            </div>
        </div>
    </b-modal>

    <!-- Feedback Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this feedback?</div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'is_satisfied',
                    label: 'Satisfaction',
                    sortable: true
                },
                {
                    key: 'userFeedback',
                    label: 'Feedback',
                    sortable: false
                },
                {
                    key: 'prompt',
                    label: 'Prompt',
                    sortable: false
                },
                {
                    key: 'ai_result',
                    label: 'AI Result',
                    sortable: false
                },
                {
                    key: 'created_at',
                    label: 'Created At',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            delete_value: null,
            prev: null,
            result: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            feedback_list: state => state.feedback.feedback,
            loading: state => state.feedback.feedbackLoading,
            error: state => state.feedback.feedbackError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.feedback,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("feedback/fetchFeedback").then(() => {
            this.items = this.feedback_list
            this.totalRows = this.feedback_list.length;
        });
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        viewFeedback(feedback) {
            this.$bvModal.show('modal-view-feedback');
            this.prev = feedback.prompt;
            this.result = feedback.ai_result;
        },

        deleteFeedback(id) {
            this.delete_value = id
        },

        formatDate(dateStr) {
            if (!dateStr) return ''

            // Split date and time manually
            const [datePart, timePart] = dateStr.replace('Z', '').split('T')

            const [year, month, day] = datePart.split('-')
            const [hourRaw, minute] = timePart.split(':')

            const hours = parseInt(hourRaw)

            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ]

            const monthName = monthNames[parseInt(month) - 1]

            const ampm = hours >= 12 ? 'PM' : 'AM'
            const hour12 = hours % 12 || 12

            const getOrdinal = (n) => {
                const s = ['th', 'st', 'nd', 'rd']
                const v = n % 100
                return s[(v - 20) % 10] || s[v] || s[0]
            }

            return {
                date: `${parseInt(day)}${getOrdinal(parseInt(day))} ${monthName}, ${year}`,
                time: `${hour12}:${minute} ${ampm}`
            }
        },

        handleDeleteOk() {
            this.$store.dispatch("feedback/deleteFeedback", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
